export default "__VITE_ASSET__CtuQaElg__"